"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixSDK = void 0;
var creator_1 = require("@wix/js-sdk-wrapper/creator");
var isWixSDKAvailable = typeof Wix !== 'undefined' &&
    // in BM env window.Wix is different SDK without instance re-validation support
    Wix.hasOwnProperty('revalidateSession');
exports.WixSDK = isWixSDKAvailable ? creator_1.wixSdk(Wix) : null;
//# sourceMappingURL=wixSdk.js.map